import { render, staticRenderFns } from "./ShowWorkbookModalComponent.vue?vue&type=template&id=62d079e0&scoped=true&"
import script from "./ShowWorkbookModalComponent.vue?vue&type=script&lang=js&"
export * from "./ShowWorkbookModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d079e0",
  null
  
)

export default component.exports